import { useMutation } from "@tanstack/react-query";
import apiUpdateService from "services/apiUpdateService";

interface IReleaseNoteViewed {
  releaseNoteId: string;
}

const sendReleaseNoteViewed = async (body: IReleaseNoteViewed) => {
  const { data } = await apiUpdateService.post(
    `/registryReleaseNotification/create`,
    body
  );
  return data;
};

export const useSendReleaseNoteViewed = (options?: any) => {
  return useMutation(sendReleaseNoteViewed, {
    ...options,
  });
};
